import RecordedExpressionsModal from "./RecordedExpressionsModal";

export default RecordedExpressionsModal;